import LoadingSpinner from '@/components/Loaders/LoadingSpinner.vue';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    components: { LoadingSpinner },
});
